import CustomCell from './Cell';

export default CustomCell;



// WEBPACK FOOTER //
// ./src/components/grids/SolicitationsGrid/subcomponents/CustomCell/index.jsx